import styled from 'styled-components';
import media from 'themes/media';

export default styled.div`
  display: inline-block;
  margin: 0 4px;
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.background.borderColor};
  color: ${(props) => props.theme.colors.text.componentTextColor};
  background: ${(props) => props.color || props.theme.colors.background.tagBackground};
  ${media.lessThan('tablet')`
    margin: 0;
    max-width: fit-content;
  `}
`;
